import { Card, Typography, useTheme } from "@mui/material"
import { Box } from "@mui/system"
import { TodoListWrapper } from "components/dataDisplay/TodoList/TodoListWrapper"
import WorkOrderCardDetails from "./WorkOrderCardDetails"
import WorkOrderCardDropdown from "./WorkOrderCardDropdown"
import WorkOrderCardReadMessage from "./WorkOrderCardReadMessage"
import WordOrderCardReportList from "./WorkOrderCardReportList"
import WorkOrderCardWriteMessage from "./WorkOrderCardWriteMessage"

const WorkOrderCard = (props) => {
  const {
    vehiclesResult,
    initialValues,
    values,
    setFieldValue,
    setVehicle,
    handleChange,
    handleBlur,
    touched,
    errors,
    status,
    t,
    vehicleId,
    vehicleIdFromDash
  } = props
  const theme = useTheme()

  return (
    <Card>
      {status > 1 && values.message && (
        <>
          <WorkOrderCardReadMessage
            bgColor={theme.palette.grey[100]}
            title={t("issuereports.message_to_workshop", "Message to workshop")}
            message={values.message}
          />
        </>
      )}

      {status > 1 && <WorkOrderCardDetails bgColor={theme.palette.grey[100]} values={values} />}

      {status < 2 && (
        <Box py={{ xs: 3, md: 4 }} px={3}>
          <WorkOrderCardDropdown
            t={t}
            vehicleIdFromDash={vehicleIdFromDash}
            initialValues={initialValues}
            vehicleId={vehicleId}
            vehiclesResult={vehiclesResult}
            setFieldValue={setFieldValue}
            setVehicle={setVehicle}
            values={values}
            handleChange={handleChange}
            handleBlur={handleBlur}
            touched={touched}
            errors={errors}
          />
          <WorkOrderCardWriteMessage
            t={t}
            values={values}
            handleChange={handleChange}
            handleBlur={handleBlur}
            touched={touched}
            errors={errors}
          />
        </Box>
      )}

      <Box p={4}>
        <Typography mb={2} variant="h6">
          {status !== 1
            ? t("issuereports.issuereports", "Issue reports")
            : t("issuereports.select_issuereports", "Select issue reports")}
        </Typography>

        <TodoListWrapper>
          {values.status > 1
            ? values.issueReports
                .filter((x) => x.added)
                .map((issueReport, index) => (
                  <WordOrderCardReportList
                    t={t}
                    setFieldValue={setFieldValue}
                    values={values}
                    issueReport={issueReport}
                    index={index}
                  />
                ))
            : values.issueReports.map((issueReport, index) => (
                <WordOrderCardReportList
                  t={t}
                  setFieldValue={setFieldValue}
                  values={values}
                  issueReport={issueReport}
                  index={index}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  touched={touched}
                  errors={errors}
                />
              ))}
        </TodoListWrapper>
      </Box>
    </Card>
  )
}

export default WorkOrderCard
